import { render } from "./NotificationContainer.vue?vue&type=template&id=373287bc&scoped=true"
import script from "./NotificationContainer.vue?vue&type=script&lang=js"
export * from "./NotificationContainer.vue?vue&type=script&lang=js"

import "./NotificationContainer.vue?vue&type=style&index=0&id=373287bc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-373287bc"

export default script